import { defineTool } from "./core.js";
export class ConfirmationDeniedError extends Error {
    constructor(toolName) {
        super(`"${toolName}" requires human confirmation, which was declined.`);
        this.name = "ConfirmationDeniedError";
    }
}
/**
 * Wraps a tool so its handler only runs after a human explicitly confirms.
 * `confirm` is supplied by the app (typically a UI dialog); if it resolves
 * false, the handler never runs and the agent gets a clear refusal instead
 * of a silent no-op. Use for every consequential or irreversible tool
 * (bulk mutations, merges, submission).
 */
export function withConfirmation(tool, confirm) {
    return defineTool({
        ...tool,
        annotations: { ...tool.annotations, destructiveHint: true },
        async handler(input) {
            const approved = await confirm(input, { name: tool.name, description: tool.description });
            if (!approved)
                throw new ConfirmationDeniedError(tool.name);
            return tool.handler(input);
        },
    });
}
